import { __assign } from "tslib";
import * as React from 'react';
import * as LinesEllipsisLoose from 'react-lines-ellipsis/lib/loose'; //https://www.npmjs.com/package/react-lines-ellipsis
import { setOpacity } from '../../../../utils/colorUtils';
import ColorIndicator from '../ColorIndicator';
import WhiteBackground from '../WhiteBackground';
import TimeRenderer from '../TimeRenderer';
import EventHover from '../EventHover';
import { st, classes } from './MoreOneHourEvent.st.css';
import WixStylesContext from '../../../../context/wixStylesContext';
import { EVENT_BACKGROUND_OPACITY } from '../../../../constants';
var MoreOneHourEvent = function (_a) {
    var event = _a.event, titleToDisplay = _a.titleToDisplay, ariaLabel = _a.ariaLabel, isMobile = _a.isMobile;
    var opacity = EVENT_BACKGROUND_OPACITY;
    var constentRef = React.useRef(null);
    var wrapperRef = React.useRef(null);
    var _b = React.useContext(WixStylesContext), isGoogleColor = _b.isGoogleColor, eventTimeFont = _b.eventTimeFont, eventTitleFont = _b.eventTitleFont;
    var backgroundColor = isGoogleColor
        ? setOpacity(opacity, event.extendedProps.googleColor)
        : setOpacity(opacity, event.extendedProps.eventColor);
    var pastEvent = event.extendedProps.pastEvent;
    var isAllDay = event.extendedProps.isAllDay;
    var count = titleToDisplay.split(' ').length;
    var padding = 8;
    var lineHeight = 
    //@ts-ignore
    typeof eventTitleFont === 'undefined' || eventTitleFont.size < 16
        ? '16'
        : //@ts-ignore
            eventTitleFont.size;
    var height;
    if (typeof eventTitleFont === 'undefined' ||
        typeof eventTimeFont === 'undefined') {
        height = lineHeight;
    }
    else {
        height =
            //@ts-ignore
            eventTitleFont.size > eventTimeFont.size
                ? //@ts-ignore
                    eventTitleFont.size
                : //@ts-ignore
                    eventTimeFont.size;
    }
    var _c = React.useState('1'), linesContentNumber = _c[0], setlinesContentNumber = _c[1];
    var _d = React.useState('3'), linesWrapperNumber = _d[0], setlinesWrapperNumber = _d[1];
    React.useEffect(function () {
        var countLines = function (ref, set) {
            if (ref && ref.current && !isAllDay) {
                var lines = ((ref.current.clientHeight - height - padding) / height - 1) | 0;
                set((lines < 0 ? 0 : lines) + '');
            }
        };
        countLines(constentRef, setlinesContentNumber);
        countLines(wrapperRef, setlinesWrapperNumber);
    }, [eventTitleFont, eventTimeFont, height]);
    var titleHeight = 12;
    if (typeof eventTitleFont !== 'undefined') {
        //@ts-ignore
        titleHeight = eventTitleFont.size;
    }
    var moreOneHourEventTitleStyle = function () {
        var style = {
            overflow: '',
            whiteSpace: '',
            width: '',
            marginBottom: '',
        };
        if (+linesContentNumber === 0) {
            style.marginBottom = '2px';
            if (count < 3) {
                style.overflow = 'hidden';
                style.whiteSpace = 'nowrap';
                style.width = '100%';
            }
            if (titleHeight > 14) {
                style.marginBottom = '4px';
            }
        }
        else if (+linesContentNumber > 0) {
            style.marginBottom = '4px';
            if (count < 3) {
                style.overflow = 'hidden';
                style.whiteSpace = 'nowrap';
                style.width = '100%';
            }
            if (titleHeight > 14) {
                style.marginBottom = '8px';
            }
        }
        return style;
    };
    return (React.createElement("div", { className: st(classes.root, { isAllDay: isAllDay, pastEvent: pastEvent, isMobile: isMobile }) },
        React.createElement(ColorIndicator, { event: event }),
        React.createElement(WhiteBackground, null,
            React.createElement(EventHover, { event: event, ariaLabel: ariaLabel, isMobile: isMobile }),
            React.createElement("div", { style: { backgroundColor: backgroundColor }, ref: wrapperRef, className: classes.MoreOneHourEventWrapper },
                React.createElement("div", { ref: constentRef, className: classes.MoreOneHourEventContent },
                    React.createElement(LinesEllipsisLoose, { className: classes.MoreOneHourEventTitle, style: __assign({}, moreOneHourEventTitleStyle()), text: titleToDisplay, maxLine: "".concat(linesWrapperNumber), lineHeight: lineHeight }),
                    isMobile || React.createElement(TimeRenderer, { event: event, lessOneHour: false }))))));
};
export default MoreOneHourEvent;
//# sourceMappingURL=MoreOneHourEvent.js.map